import { render } from "./WorkListRate.vue?vue&type=template&id=b48dc79a"
import script from "./WorkListRate.vue?vue&type=script&lang=js"
export * from "./WorkListRate.vue?vue&type=script&lang=js"

import "./WorkListRate.vue?vue&type=style&index=0&id=b48dc79a&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__